// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { LinksGetAllRequestParams, LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PagesFilesPagesComponent } from '@client/app/components/pages/files/pages/pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';

@Component({
    selector: 'pages-files',
    templateUrl: './pages-files.component.html',
    standalone: false,
})
export class PagesFilesComponent extends BaseContainerComponentController implements OnInit {
    @Input() type: any;
    @Input() lookFor?: any;
    @Input() domainId: any;
    @Input() singularName: string = '';
    @Input() icon: any;
    @Input() status?: any;

    scanDocuments = false;
    links: any = [];
    override search: string = '';
    override activeTab: string = '';
    exports: any = {};
    tabs: any[] = [];
    promise: any;

    constructor (
        private linksRepoService: LinksRepoService,
        private monEventService: MonEventService,
        private translateService: TranslateService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.scanDocuments = this.sessionService?.domain?.scan?.scan_documents || false;
        this.links = [];
        this.links.total = 0;
        if (this.singularName) {
            this.singularName = this.singularName.toLowerCase();
        } else {
            this.singularName = this.type.name.substring(0, this.type.name.length - 1).toLowerCase();
        }
        this.status = this.status || null;
        this.activeTab = this.scanDocuments ? 'internal' : '';

        this.exports = {
            pdf: [
                {
                    name: this.translateService.getString('Export both internal and external links'),
                    data: {
                        category: 'inventory_pdf_links',
                    },
                },
                {
                    name: this.translateService.getString('Export only internal links'),
                    data: {
                        category: 'inventory_pdf_links',
                        category_ref: 'internal',
                    },
                },
                {
                    name: this.translateService.getString('Export only external links'),
                    data: {
                        category: 'inventory_pdf_links',
                        category_ref: 'external',
                    },
                },
            ],
            spreadsheet: [
                {
                    name: this.translateService.getString('Export only internal links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'internal,spreadsheet',
                    },
                },
                {
                    name: this.translateService.getString('Export only external links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'external,spreadsheet',
                    },
                },
            ],
            archive: [
                {
                    name: this.translateService.getString('Export only internal links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'internal,archive',
                    },
                },
                {
                    name: this.translateService.getString('Export only external links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'external,archive',
                    },
                },
            ],
            document: [
                {
                    name: this.translateService.getString('Export only internal links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'internal,document',
                    },
                },
                {
                    name: this.translateService.getString('Export only external links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'external,document',
                    },
                },
            ],
            slide: [
                {
                    name: this.translateService.getString('Export only internal links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'internal,slide',
                    },
                },
                {
                    name: this.translateService.getString('Export only external links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'external,slide',
                    },
                },
            ],
            file: [
                {
                    name: this.translateService.getString('Export only internal links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'internal,file',
                    },
                },
                {
                    name: this.translateService.getString('Export only external links'),
                    data: {
                        category: 'inventory_links',
                        category_ref: 'external,file',
                    },
                },
            ],
        };

        this.setupTabs();
        this.getPage();
    }

    setupTabs () {
        if (!this.scanDocuments) {
            this.tabs = [];
            return;
        }
        this.tabs = [
            {
                name: this.translateService.getString('Internal'),
                value: 'internal',
            },
            {
                name: this.translateService.getString('External'),
                value: 'external',
            },
        ];
    }

    override getPage () {
        const params: LinksGetAllRequestParams = {
            type: this.type.type || null,
            page_size: this.pageSize,
            page: this.page,
            search: this.search ?? '',
        };
        if (this.status) {
            params.status = this.status;
        }
        if (this.activeTab) {
            params.relation = this.activeTab;
        }

        this.promise = this.linksRepoService.getAll(params).then((data: any) => {
            this.links = data;
        }, () => {});
    }

    openDialog (link: any, type: string) {
        const params = {
            body: PagesFilesPagesComponent,
            size: 'lg',
            data: { link: link, domainId: this.domainId, active: this.lookFor, type: type },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    override onSearch (search: string) {
        this.search = search;
        this.getPage();
    }

    override onStatus (tab: string) {
        this.activeTab = tab;
        this.getPage();
    }
}
